"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AssertionFailedException = _interopRequireDefault(require("./AssertionFailedException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Assert =
/*#__PURE__*/
function () {
  function Assert() {
    _classCallCheck(this, Assert);

    Assert.constructor_.apply(this, arguments);
  }

  _createClass(Assert, [{
    key: "getClass",
    value: function getClass() {
      return Assert;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "shouldNeverReachHere",
    value: function shouldNeverReachHere() {
      if (arguments.length === 0) {
        Assert.shouldNeverReachHere(null);
      } else if (arguments.length === 1) {
        var message = arguments[0];
        throw new _AssertionFailedException.default("Should never reach here" + (message !== null ? ": " + message : ""));
      }
    }
  }, {
    key: "isTrue",
    value: function isTrue() {
      if (arguments.length === 1) {
        var assertion = arguments[0];
        Assert.isTrue(assertion, null);
      } else if (arguments.length === 2) {
        var _assertion = arguments[0],
            message = arguments[1];

        if (!_assertion) {
          if (message === null) {
            throw new _AssertionFailedException.default();
          } else {
            throw new _AssertionFailedException.default(message);
          }
        }
      }
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 2) {
        var expectedValue = arguments[0],
            actualValue = arguments[1];
        Assert.equals(expectedValue, actualValue, null);
      } else if (arguments.length === 3) {
        var _expectedValue = arguments[0],
            _actualValue = arguments[1],
            message = arguments[2];

        if (!_actualValue.equals(_expectedValue)) {
          throw new _AssertionFailedException.default("Expected " + _expectedValue + " but encountered " + _actualValue + (message !== null ? ": " + message : ""));
        }
      }
    }
  }]);

  return Assert;
}();

exports.default = Assert;

Assert.constructor_ = function () {};